(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const blockTitles = document.querySelectorAll('.footer-header-container-mobile');

  blockTitles.forEach((title) => {
    title.addEventListener('click', () => {
      const block = title.nextElementSibling;
      block.style.display = block.style.display === 'none' ? 'block' : 'none';
      title.classList.toggle('open');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
